import { render } from "./SkeletonItem.vue?vue&type=template&id=2bc2f86a"
import script from "./SkeletonItem.vue?vue&type=script&lang=js"
export * from "./SkeletonItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__